import React, { useEffect, useState } from 'react'
import Api from '../../../../services/Api'
import { INFDetailFormatted } from '../../components/NFTDetail/INFTDetail'
import NFTImageSkeleton from '../../components/NFTImageSkeleton'
import { NFTPropertyItem } from '../../components/NFTProperty'
import { IBaseNFTAttributes } from '../../models/INFTProperties'
import BaseDetail from './BaseDetail'


interface IAngryBearsRarity {
  for_traits: { [key: string]: number }
  readable: string
  score: number
}

export interface IAngryBearsProps {
  id: number
  name: string
  image: string
  description: string
  externalUrl: string
  attributes: IBaseNFTAttributes[]
  rarity: IAngryBearsRarity
}

export default function AngryBearsDetail(props: INFDetailFormatted) {
  const { tokenItem, collection } = props
  const [detailTokenItem, setDetailTokenItem] = useState<IAngryBearsProps | null>(null)
  const [tokenUriControl, setTokenUriControl] = useState<boolean>(false)

  let tokenName = detailTokenItem && detailTokenItem.name ? detailTokenItem.name : collection.name

  if (detailTokenItem && !detailTokenItem.name) {
    tokenName = detailTokenItem ? `${collection.name} #${tokenItem.tokenId}` : collection.name
  }

  useEffect(() => {
    if (tokenItem && tokenItem.tokenId !== undefined && tokenItem.tokenUri && !tokenUriControl) {
      setTokenUriControl(true)
      Api.get(tokenItem.tokenUri.replace('ipfs://', 'https://ipfs.io/ipfs/')).then((tokenResult: any) =>
        setDetailTokenItem(tokenResult)
      )
    }
  }, [tokenItem, tokenUriControl])

  function getNFTProperties() {
    let result: any[] = []

    if (detailTokenItem && detailTokenItem.attributes) {
      result = detailTokenItem.attributes
        .filter(item => item.value)
        .map((item: IBaseNFTAttributes, index: number) => {
          return (
            <NFTPropertyItem key={`PROPERTY_${index}`} className={`property-item`}>
              <div className="wrapper">
                <div className="type" title={item.trait_type}>
                  {item.trait_type}
                </div>
                <div className="name" title={item.value}>
                  <div>{item.value}</div>
                  <div>({detailTokenItem.rarity.for_traits[item.trait_type]}%)</div>
                </div>
              </div>
            </NFTPropertyItem>
          )
        })

      result.unshift(
        <NFTPropertyItem key={`PROPERTY_SCORE`} className={`property-item`}>
          <div className="wrapper" style={{ minHeight: '94px' }}>
            <div className="type" title="Score">
              Score
            </div>
            <div className="name" title={detailTokenItem.rarity.score.toString()}>
              <div style={{ fontSize: '1.2rem' }}>{detailTokenItem.rarity.score}</div>
            </div>
          </div>
        </NFTPropertyItem>
      )

      result.unshift(
        <NFTPropertyItem key={`PROPERTY_CLASS`} className={`property-item`}>
          <div className="wrapper" style={{ minHeight: '94px' }}>
            <div className="type" title="Class">
              Score
            </div>
            <div className="name" title={detailTokenItem.rarity.readable}>
              <div style={{ fontSize: '1.2rem' }}>{detailTokenItem.rarity.readable}</div>
            </div>
          </div>
        </NFTPropertyItem>
      )
    }

    return result
  }

  return (
    <BaseDetail
      {...props}
      description={<div>The Angry Bears are coming to your favorite blockchain very soon! Stay tuned. 1,500 exclusive bears. 20% of the funds raised will be donated to WWF.</div>}
      tokenItemName={tokenName}
      externalUrl={detailTokenItem?.externalUrl}
      customProperties={getNFTProperties()}
    >
      {detailTokenItem ? (
        <img src={detailTokenItem.image.replace('ipfs://', 'https://ipfs.io/ipfs/')} alt={tokenName} />
      ) : (
        <NFTImageSkeleton />
      )}
    </BaseDetail>
  )
}
